export default {};
export const CLOSED = {};
export const CLOSING = {};
export const CONNECTING = {};
export const EventEmitter = {};
export const EventEmitterAsyncResource = {};
export const OPEN = {};
export const Receiver = {};
export const Sender = {};
export const Server = {};
export const WebSocket = {};
export const WebSocketServer = {};
export const addAbortListener = {};
export const captureRejectionSymbol = {};
export const captureRejections = {};
export const createWebSocketStream = {};
export const defaultMaxListeners = {};
export const errorMonitor = {};
export const getEventListeners = {};
export const getMaxListeners = {};
export const init = {};
export const listenerCount = {};
export const on = {};
export const once = {};
export const prototype = {};
export const setMaxListeners = {};
export const usingDomains = {};